var hasOwnProp = require('../base/hasOwnProp')

function objectEach (obj, iterate, context) {
  if (obj) {
    for (var key in obj) {
      if (hasOwnProp(obj, key)) {
        iterate.call(context, obj[key], key, obj)
      }
    }
  }
}

module.exports = objectEach



//////////////////
// WEBPACK FOOTER
// ./node_modules/xe-utils/methods/object/objectEach.js
// module id = WcL7
// module chunks = 0